import { emptyProgress, type ProgressData } from '../core/progress';

// Per-user progress sync against the backend HTTP API (see infra/stacks/backend_stack.py).
const API_URL = import.meta.env.VITE_API_URL as string | undefined;

export function isConfigured(): boolean {
  return !!API_URL;
}

export async function loadRemote(token: string): Promise<ProgressData> {
  if (!API_URL) return emptyProgress();
  const res = await fetch(`${API_URL}/progress`, {
    headers: { authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`load progress failed: ${res.status}`);
  return (await res.json()) as ProgressData;
}

export async function saveRemote(token: string, data: ProgressData): Promise<void> {
  if (!API_URL) return;
  const res = await fetch(`${API_URL}/progress`, {
    method: 'PUT',
    headers: { authorization: `Bearer ${token}`, 'content-type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`save progress failed: ${res.status}`);
}
